/**
 * Do not edit directly
 */

export default "PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTAuNSAwVjNIMTUuNVY0SDAuNVYzSDUuNVYwSDEwLjVaTTYuNSAxVjNIOS41VjFINi41Wk0xMy41IDE1SDIuNVY2SDEuNVYxNS41QzEuNSAxNS43NzYxIDEuNzIzODYgMTYgMiAxNkgxNEMxNC4yNzYxIDE2IDE0LjUgMTUuNzc2MSAxNC41IDE1LjVWNkgxMy41VjE1Wk04LjUgN0g3LjVWMTNIOC41VjdaTTEwLjUgN0gxMS41VjEzSDEwLjVWN1pNNS41IDdINC41VjEzSDUuNVY3WiIvPjwvc3ZnPg==";